const CAPACITY_STATUS = {
  available: "AVAILABLE",
  booked: "BOOKED",
  offDuty: "OFF_DUTY",
};

export default CAPACITY_STATUS;
